import React from 'react';
import { Product } from '../types';
import { useNavigate } from 'react-router-dom';

interface SearchSuggestionsProps {
  suggestions: Product[];
  onSelect: () => void;
  isLoading: boolean;
}

export function SearchSuggestions({ suggestions, onSelect, isLoading }: SearchSuggestionsProps) {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-brand-green/10 overflow-hidden z-[100] p-4">
        <div className="flex items-center space-x-3 animate-pulse">
          <div className="h-10 w-10 bg-light-grey rounded-lg" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-light-grey rounded w-3/4" />
            <div className="h-3 bg-light-grey rounded w-1/4" />
          </div>
        </div>
      </div>
    );
  }

  if (suggestions.length === 0) return null;

  return (
    <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-brand-green/10 overflow-hidden z-[100]">
      <div className="p-2 border-b border-light-grey bg-off-white/50">
        <span className="text-[10px] uppercase tracking-widest font-bold text-brand-green/60 px-2">
          Top Suggestions
        </span>
      </div>
      <div className="max-h-[300px] overflow-y-auto">
        {suggestions.map((product) => (
          <button
            key={product.id}
            className="w-full flex items-center p-3 hover:bg-brand-green/5 transition-colors text-left group border-b border-light-grey last:border-0"
            onClick={() => {
              navigate(`/product/${product.slug}`);
              onSelect();
            }}
          >
            <div className="h-12 w-12 rounded-lg overflow-hidden bg-light-grey shrink-0 border border-border group-hover:border-brand-green/20 transition-colors">
              <img
                src={product.images[0] || '/placeholder.png'}
                alt={product.name}
                className="h-full w-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
            <div className="ml-4 flex-1">
              <h4 className="text-sm font-medium text-brand-green group-hover:text-brand-green transition-colors line-clamp-1">
                {product.name}
              </h4>
              <div className="flex items-center mt-0.5 space-x-2">
                <span className="text-xs font-bold text-brand-green">
                  ₹{product.price.toLocaleString('en-IN')}
                </span>
                {product.material && (
                  <span className="text-[10px] bg-brand-green/10 text-brand-green px-1.5 py-0.5 rounded uppercase font-bold tracking-wider">
                    {product.material}
                  </span>
                )}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
